import { all } from 'redux-saga/effects';
import packages from './package';

export const packageSaga = function* root() {
  yield all([packages()]);
};
